<template>
<div class="mappatura-piatti-page">
    <!-- Top Header Navigation -->
    <header class="sci-header">
        <div class="header-content">
            <div class="header-left">
                <button type="button" class="sci-btn sci-btn-ghost btn-back" @click.prevent="home" title="Torna al Gestionale">
                    <i class="fas fa-arrow-left me-2"></i>Home
                </button>
                <div class="header-title-box">
                    <h2 class="header-title">
                        <i class="fas fa-sitemap text-primary me-2"></i>Mappatura Piatti & Food Cost
                    </h2>
                    <span class="header-badge" v-if="vocemenu">{{ vocemenu }}</span>
                </div>
            </div>
            <div class="header-actions" v-if="vocemenu">
                <button type="button" class="sci-btn sci-btn-primary" @click.prevent="salvaRicetta">
                    <i class="fas fa-save me-2"></i>Salva Ricetta
                </button>
            </div>
        </div>
    </header>

    <!-- Modals Backdrop -->
    <div class="sci-modal-backdrop" v-if="showAggiunte || showSenza" @click="closeModals"></div>
    
    <!-- Modal Aggiunte Possibili -->
    <div class="sci-modal" v-if="showAggiunte" role="dialog" aria-modal="true">
        <div class="sci-modal-dialog">
            <div class="sci-modal-card">
                <div class="sci-modal-header">
                    <div>
                        <h4 class="mb-0 fw-bold text-dark"><i class="fas fa-plus-circle text-primary me-2"></i>Aggiunte Possibili</h4>
                        <small class="text-muted">Seleziona le varianti o supplementi per {{ vocemenu }}</small>
                    </div>
                    <button type="button" class="sci-btn-close" @click="showAggiunte = false">&times;</button>
                </div>
                <div class="sci-modal-search">
                    <i class="fas fa-search search-icon"></i>
                    <input type="text" v-model="searchModalAggiunte" placeholder="Cerca tra i prodotti..." class="sci-input search-input" />
                </div>
                <div class="sci-modal-body">
                    <div class="touch-option-grid">
                        <label v-for="(prodotto, index) in filteredModalAggiunte" :key="'map_add_' + index" class="touch-option-card" :class="{ 'is-checked': add.includes(prodotto.nome || prodotto.descrizio) }">
                            <input type="checkbox" class="sci-checkbox" :id="'map_add_' + index" v-model="add" :value="prodotto.nome || prodotto.descrizio">
                            <div class="option-details">
                                <span class="option-name">{{prodotto.nome || prodotto.descrizio}}</span>
                                <span class="option-price" v-if="prodotto.prezzoAggiunta">+€{{ Number(prodotto.prezzoAggiunta).toFixed(2) }}</span>
                            </div>
                        </label>
                    </div>
                </div>
                <div class="sci-modal-footer">
                    <button type="button" class="sci-btn sci-btn-primary w-100" @click="showAggiunte = false">
                        <i class="fas fa-check me-2"></i>Conferma Aggiunte ({{ add.length }})
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Modal Senza (Ingredienti Rimovibili) -->
    <div class="sci-modal" v-if="showSenza" role="dialog" aria-modal="true">
        <div class="sci-modal-dialog">
            <div class="sci-modal-card">
                <div class="sci-modal-header">
                    <div>
                        <h4 class="mb-0 fw-bold text-dark"><i class="fas fa-minus-circle text-danger me-2"></i>Possono Togliere</h4>
                        <small class="text-muted">Seleziona gli ingredienti che il cliente può escludere</small>
                    </div>
                    <button type="button" class="sci-btn-close" @click="showSenza = false">&times;</button>
                </div>
                <div class="sci-modal-search">
                    <i class="fas fa-search search-icon"></i>
                    <input type="text" v-model="searchModalSenza" placeholder="Cerca tra i prodotti..." class="sci-input search-input" />
                </div>
                <div class="sci-modal-body">
                    <div class="touch-option-grid">
                        <label v-for="(prodotto, index) in filteredModalSenza" :key="'map_rem_' + index" class="touch-option-card is-minus" :class="{ 'is-checked': minus.includes(prodotto.nome || prodotto.descrizio) }">
                            <input type="checkbox" class="sci-checkbox" :id="'map_rem_' + index" v-model="minus" :value="prodotto.nome || prodotto.descrizio">
                            <div class="option-details">
                                <span class="option-name">{{prodotto.nome || prodotto.descrizio}}</span>
                            </div>
                        </label>
                    </div>
                </div>
                <div class="sci-modal-footer">
                    <button type="button" class="sci-btn sci-btn-primary w-100" @click="showSenza = false">
                        <i class="fas fa-check me-2"></i>Conferma Ingredienti Rimovibili ({{ minus.length }})
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Main Container -->
    <div class="main-container">
        <!-- Dish Selection Bento Card -->
        <div class="sci-card selection-card">
            <div class="selection-box">
                <div class="selection-label-group">
                    <label class="form-label-sci"><i class="fas fa-book-open text-primary me-2"></i>Seleziona il Piatto da Mappare</label>
                    <small class="text-muted d-block">Scegli una portata dal tuo menù per visualizzare o comporre la distinta base degli ingredienti</small>
                </div>
                <div class="selection-input-group">
                    <select class="sci-input sci-select dish-select" v-model="selectedDishKey" @change="voceMenuChange">
                        <option disabled value="">-- Seleziona un piatto dal menù --</option>
                        <option :value="piattoItem.nome + '|' + (piattoItem.portata || '')" v-for="piattoItem in piatti" :key="piattoItem.id + '-' + piattoItem.nome">
                            {{piattoItem.nome}} ({{piattoItem.portata || 'Generale'}}) — € {{ Number(piattoItem.prezzo || 0).toFixed(2) }}
                        </option>
                    </select>
                </div>
            </div>
        </div>

        <!-- Recipe & Food Cost Studio -->
        <div v-if="vocemenu" class="recipe-studio-layout">
            <!-- Studio Metrics Card -->
            <div class="sci-card metrics-card">
                <div class="metrics-grid">
                    <div class="metric-item">
                        <span class="metric-label">Piatto Selezionato</span>
                        <strong class="metric-value text-dark">{{ vocemenu }}</strong>
                        <span class="badge bg-secondary text-white text-capitalize mt-1">{{ portata || 'Standard' }}</span>
                    </div>

                    <div class="metric-item">
                        <span class="metric-label">Prezzo Vendita</span>
                        <strong class="metric-value text-primary">€ {{ getDishPrice() }}</strong>
                        <small class="text-muted">Prezzo al pubblico</small>
                    </div>

                    <div class="metric-item">
                        <span class="metric-label">Costo Totale Ricetta (Food Cost)</span>
                        <strong class="metric-value text-danger">€ {{ costoTotaleRicetta }}</strong>
                        <small class="text-muted">Somma materie prime</small>
                    </div>

                    <div class="metric-item">
                        <span class="metric-label">Margine & Incidenza %</span>
                        <strong class="metric-value" :class="getFoodCostRatio() <= 35 ? 'text-success' : 'text-warning'">
                            {{ getFoodCostRatio() }}%
                        </strong>
                        <small class="text-muted">Margine Lordo: € {{ getGrossMargin() }}</small>
                    </div>
                </div>

                <div class="metrics-action-bar">
                    <div class="left-actions">
                        <button type="button" class="sci-btn sci-btn-outline-primary" @click="showAggiunte = true">
                            <i class="fas fa-plus-circle me-1"></i>Aggiunte Possibili
                            <span class="badge bg-primary ms-1" v-if="add.length">{{ add.length }}</span>
                        </button>
                        <button type="button" class="sci-btn sci-btn-outline-danger" @click="showSenza = true">
                            <i class="fas fa-minus-circle me-1"></i>Senza
                            <span class="badge bg-danger ms-1" v-if="minus.length">{{ minus.length }}</span>
                        </button>
                    </div>
                    <div class="right-actions">
                        <button type="button" class="sci-btn sci-btn-secondary me-2" @click="incrementcounter">
                            <i class="fas fa-plus me-1"></i>Aggiungi Ingrediente
                        </button>
                        <button type="button" class="sci-btn sci-btn-primary" @click="salvaRicetta">
                            <i class="fas fa-save me-1"></i>Salva Ricetta
                        </button>
                    </div>
                </div>
            </div>

            <!-- Ingredients List Section -->
            <div class="sci-card ingredients-card">
                <div class="card-header-bar">
                    <h4 class="card-title">
                        <i class="fas fa-boxes text-primary me-2"></i>Distinta Ingredienti & Materie Prime ({{ counter.length }})
                    </h4>
                    <button type="button" class="sci-btn sci-btn-primary btn-sm" @click="incrementcounter">
                        <i class="fas fa-plus me-1"></i>Nuovo Ingrediente
                    </button>
                </div>

                <div v-if="counter.length === 0" class="empty-state">
                    <i class="fas fa-mortar-pestle empty-icon"></i>
                    <h5>Nessun ingrediente mappato</h5>
                    <p class="text-muted">Aggiungi i prodotti e le quantità in grammi/ml per calcolare il Food Cost esatto.</p>
                    <button type="button" class="sci-btn sci-btn-primary btn-sm" @click="incrementcounter">
                        <i class="fas fa-plus me-1"></i>Aggiungi Primo Ingrediente
                    </button>
                </div>

                <div v-else class="ingredients-list">
                    <div 
                        v-for="(count, index) in counter" 
                        :key="count" 
                        class="ingredient-card-row"
                    >
                        <div class="ingredient-number">#{{ index + 1 }}</div>

                        <!-- Product Search & Selector -->
                        <div class="ingredient-product-col">
                            <div class="search-prod-box mb-2">
                                <i class="fas fa-search search-icon-sm"></i>
                                <input 
                                    type="text" 
                                    v-model="searchProd[index]" 
                                    placeholder="Filtra materie prime..." 
                                    class="sci-input search-input-sm"
                                />
                            </div>
                            <select 
                                class="sci-input sci-select" 
                                v-model="prodottomenu[index]" 
                                @change="(e) => prodottomenu[index] = e.target.value"
                            >
                                <option value="" disabled selected>-- Seleziona ingrediente --</option>
                                <option 
                                    :value="prodotto.code" 
                                    v-for="prodotto in filteredProdotti(index)" 
                                    :key="prodotto.code"
                                >
                                    {{ prodotto.descrizio || prodotto.nome }} — € {{ Number(prodotto.prezzo || 0).toFixed(2) }}/100g
                                </option>
                            </select>
                        </div>

                        <!-- Quantity Input -->
                        <div class="ingredient-quantity-col">
                            <label class="small text-muted fw-bold mb-1 d-block">Quantità (g / ml / pz)</label>
                            <div class="quantity-input-box">
                                <input 
                                    type="text" 
                                    inputmode="decimal" 
                                    v-model="quantitaProdotto[index]" 
                                    @input="(e) => filterQuantityInput(index, e.target.value)" 
                                    class="sci-input quantity-input" 
                                    placeholder="es. 150"
                                />
                                <span class="quantity-unit">q.tà</span>
                            </div>
                        </div>

                        <!-- Cost Badge -->
                        <div class="ingredient-cost-col">
                            <span class="small text-muted fw-bold mb-1 d-block">Costo</span>
                            <span class="costo-badge">€ {{ calcolaCostoProdotto(index) }}</span>
                        </div>

                        <!-- Delete Action -->
                        <div class="ingredient-actions-col">
                            <button 
                                type="button" 
                                class="sci-btn sci-btn-ghost btn-delete-row" 
                                @click="rimuoviProdotto(index)" 
                                title="Rimuovi ingrediente"
                            >
                                <i class="fas fa-trash-alt text-danger"></i>
                            </button>
                        </div>
                    </div>
                </div>

                <div class="card-footer-bar" v-if="counter.length > 0">
                    <div class="d-flex justify-content-between align-items-center w-100">
                        <button type="button" class="sci-btn sci-btn-ghost" @click="incrementcounter">
                            <i class="fas fa-plus me-2"></i>Aggiungi un altro ingrediente
                        </button>
                        <div class="d-flex align-items-center gap-3">
                            <span class="total-label text-muted">Totale Ricetta:</span>
                            <strong class="total-price text-danger fs-5">€ {{ costoTotaleRicetta }}</strong>
                            <button type="button" class="sci-btn sci-btn-primary ms-2" @click="salvaRicetta">
                                <i class="fas fa-check me-2"></i>Salva Ricetta
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-else class="sci-card placeholder-card text-center py-5">
            <i class="fas fa-hand-pointer placeholder-icon"></i>
            <h4>Seleziona un piatto in alto per iniziare</h4>
            <p class="text-muted">Potrai configurare gli ingredienti, calcolare il costo delle porzioni e impostare le varianti.</p>
        </div>
    </div>
</div>
</template>

<script>
import { store } from '../store/store.js'

export default {
  name: 'MappaturaPiatti',
  data: function () {
    return {
        prodotti: [],
        show: false,
        piatti: [],
        vocemenu: '',
        selectedDishKey: '',
        counter: [],
        prodottomenu: [],
        quantitaProdotto: [],
        piatto: [],
        portata: '',
        add: [],
        minus: [],
        addPrice: [],
        showAggiunte: false,
        showSenza: false,
        searchProd: [],
        selectedMenuId: null,
        searchModalAggiunte: '',
        searchModalSenza: '',
        store
    }
  },
  computed: {
    costoTotaleRicetta() {
        let totale = 0;
        this.counter.forEach((_, index) => {
            totale += parseFloat(this.calcolaCostoProdotto(index));
        });
        return totale.toFixed(2);
    },
    filteredModalAggiunte() {
        const list = this.prodotti || [];
        if (!this.searchModalAggiunte || !this.searchModalAggiunte.trim()) return list;
        const q = this.searchModalAggiunte.trim().toLowerCase();
        return list.filter(p => (p.descrizio || p.nome || '').toLowerCase().includes(q));
    },
    filteredModalSenza() {
        const list = this.prodotti || [];
        if (!this.searchModalSenza || !this.searchModalSenza.trim()) return list;
        const q = this.searchModalSenza.trim().toLowerCase();
        return list.filter(p => (p.descrizio || p.nome || '').toLowerCase().includes(q));
    }
  },
  methods: {
    getDishPrice() {
        const d = this.piatti.find(p => p.nome === this.vocemenu && p.portata === this.portata);
        return d && d.prezzo ? Number(d.prezzo).toFixed(2) : '0.00';
    },
    getGrossMargin() {
        const price = parseFloat(this.getDishPrice()) || 0;
        const cost = parseFloat(this.costoTotaleRicetta) || 0;
        return (price - cost).toFixed(2);
    },
    getFoodCostRatio() {
        const price = parseFloat(this.getDishPrice()) || 0;
        const cost = parseFloat(this.costoTotaleRicetta) || 0;
        if (price <= 0) return 0;
        return Math.round((cost / price) * 100);
    },
    closeModals() {
        this.showAggiunte = false;
        this.showSenza = false;
    },
    home() {
        this.$router.push({ name: "Gestionale" });
    },
    displayProduct() {
        this.axios.post(this.store.path + 'displayProduct', {
            headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
        }).then((response) => {
            if(response.data.messaggio){
                this.prodotti = response.data.messaggio;
            }
        }).catch(err => console.error("Errore caricamento prodotti:", err));
    },
    displayMenu() {
        this.axios.post(this.store.path + 'displayMenu', {
            headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
        }).then((response) => {
            if(response.data.messaggio){
                this.piatti = response.data.messaggio;
            }
        }).catch(err => console.error("Errore caricamento menu:", err));
    },
    salvaRicetta() {
        const newP = this.piatto.length ? false : true;
        const cleanQuantita = this.quantitaProdotto.map(q => {
            const cleanStr = String(q || '0').replace(',', '.');
            return parseFloat(cleanStr) || 0;
        });
        this.axios.post(this.store.path + 'salvaRicetta', {
            descrizi: this.vocemenu, 
            portata: this.portata, 
            menuId: this.selectedMenuId, 
            prodotti: this.prodottomenu, 
            quantita: cleanQuantita, 
            newP: newP,
            headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
        }).then((response) => {
            if(response.data.messaggio){
                alert("Ricetta salvata con successo!");
                this.displayMenu();
            }
        }).catch(err => {
            console.error("Errore salvataggio ricetta:", err);
            alert("Errore durante il salvataggio della ricetta.");
        });

        // Update variations if present
        let selectedDish = this.piatti.find(p => p.nome === this.vocemenu && p.portata === this.portata);
        if (selectedDish) {
            this.addPrice = [];
            this.add.forEach(element => {
                let product = this.prodotti.find(o => o.descrizio === element || o.nome === element);
                if (product) {
                    this.addPrice.push({ nome: product.nome || product.descrizio, prezzo: product.prezzoAggiunta ? product.prezzoAggiunta : 0 });
                }
            });
            this.axios.post(this.store.path + `update`, {
                nome: this.vocemenu,
                prezzo: selectedDish.prezzo,
                descrizione: selectedDish.descrizione,
                portata: selectedDish.portata,
                addProd: this.add,
                removeProd: this.minus,
                addPrice: this.addPrice,
                headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
            }).catch(e => console.error("Errore varianti:", e));
        }
    },
    voceMenuChange() {
        if (!this.selectedDishKey) return;
        const parts = this.selectedDishKey.split('|');
        const nome = parts[0];
        const portata = parts[1] || '';
        this.vocemenu = nome;
        this.portata = portata;
        const selectedDish = this.piatti.find(p => p.nome === nome && p.portata === portata);
        this.selectedMenuId = selectedDish ? selectedDish.id : null;
        this.displayPiatto(nome, portata);
    },
    displayPiatto(descrizi, portata) {
        this.prodottomenu = [];
        this.quantitaProdotto = [];
        this.counter = [];
        this.piatto = [];
        this.axios.post(this.store.path + 'displayPiatto', {
            descrizi: descrizi,
            portata: portata,
            headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
        }).then((response) => {
            if(response.data.messaggio){
                response.data.messaggio.forEach((element, i) => {
                    this.counter.push(Date.now() + i);
                    this.prodottomenu[i] = element.nome;
                    this.quantitaProdotto[i] = element.quantita != null ? String(element.quantita).replace('.', ',') : '';
                });
                this.piatto.push('1');
            }

            // Sync variations
            let selectedDish = this.piatti.find(p => p.nome === descrizi && p.portata === portata);
            if (selectedDish) {
                this.add = selectedDish.addProd ? selectedDish.addProd : [];
                this.minus = selectedDish.removeProd ? selectedDish.removeProd : [];
            }
        }).catch(err => console.error("Errore displayPiatto:", err));
    },
    incrementcounter() {
        this.counter.push(Date.now());
    },
    filteredProdotti(index) {
        const query = (this.searchProd[index] || '').toLowerCase();
        const currentSelected = this.prodottomenu[index];
        return this.prodotti.filter(prodotto => {
            const matches = (prodotto.descrizio || '').toLowerCase().includes(query) || 
                          (prodotto.nome || '').toLowerCase().includes(query) ||
                          (prodotto.code || '').toLowerCase().includes(query);
            return matches || prodotto.code === currentSelected;
        });
    },
    rimuoviProdotto(index) {
        const productName = this.prodottomenu[index];
        if (this.piatto.length && productName) {
            this.axios.post(this.store.path + 'rimuoviIngrediente', {
                descrizi: this.vocemenu,
                portata: this.portata,
                nomeIngrediente: productName,
                headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
            }).catch(err => console.error("Errore rimozione ingrediente:", err));
        }
        
        this.prodottomenu.splice(index, 1);
        this.quantitaProdotto.splice(index, 1);
        this.counter.splice(index, 1);
        if (this.searchProd) this.searchProd.splice(index, 1);
    },
    filterQuantityInput(index, value) {
        let sanitized = value.replace(/[^0-9.,]/g, '');
        const firstSeparatorIndex = sanitized.search(/[.,]/);
        if (firstSeparatorIndex !== -1) {
            const before = sanitized.slice(0, firstSeparatorIndex + 1);
            const after = sanitized.slice(firstSeparatorIndex + 1).replace(/[.,]/g, '');
            sanitized = before + after;
        }
        this.quantitaProdotto[index] = sanitized;
    },
    calcolaCostoProdotto(index) {
        const code = this.prodottomenu[index];
        const quantitaStr = String(this.quantitaProdotto[index] || '0').replace(',', '.');
        const quantita = parseFloat(quantitaStr) || 0;
        const prodotto = this.prodotti.find(p => p.code === code);
        if (prodotto && prodotto.prezzo) {
            return ((quantita / 100) * prodotto.prezzo).toFixed(2);
        }
        return '0.00';
    }
  },
  beforeMount() {
      this.displayMenu();
      this.displayProduct();
  }
}
</script>

<style scoped>
.mappatura-piatti-page {
    min-height: 100vh;
    background-color: var(--sci-bg);
    padding-bottom: 60px;
}

/* Header */
.sci-header {
    background: var(--sci-surface-glass);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border-bottom: 1px solid var(--sci-border);
    position: sticky;
    top: 0;
    z-index: 100;
    padding: 14px 24px;
}

.header-content {
    max-width: 1440px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
}

.header-left {
    display: flex;
    align-items: center;
    gap: 16px;
}

.header-title-box {
    display: flex;
    align-items: center;
    gap: 12px;
}

.header-title {
    font-size: 1.35rem;
    font-weight: 800;
    color: var(--sci-text-main);
    margin: 0;
    letter-spacing: -0.02em;
}

.header-badge {
    background: var(--sci-primary-subtle);
    color: var(--sci-primary);
    font-size: 0.75rem;
    font-weight: 700;
    padding: 4px 10px;
    border-radius: var(--radius-full);
    border: 1px solid var(--sci-primary-border);
}

/* Main Container */
.main-container {
    max-width: 1440px;
    margin: 24px auto 0 auto;
    padding: 0 20px;
}

/* Cards */
.sci-card {
    background: var(--sci-surface);
    border: 1px solid var(--sci-border);
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-card);
    overflow: hidden;
    margin-bottom: 24px;
}

/* Selection Card */
.selection-card {
    padding: 20px 24px;
}

.selection-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 24px;
    flex-wrap: wrap;
}

.selection-label-group {
    max-width: 480px;
}

.selection-input-group {
    flex: 1;
    min-width: 320px;
}

.dish-select {
    font-size: 1rem;
    font-weight: 600;
    min-height: 48px;
}

/* Metrics Grid */
.metrics-card {
    padding: 24px;
    background: linear-gradient(180deg, #ffffff 0%, var(--sci-bg-subtle) 100%);
}

.metrics-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 20px;
    margin-bottom: 20px;
}

.metric-item {
    background: #ffffff;
    border: 1px solid var(--sci-border);
    border-radius: var(--radius-md);
    padding: 16px 20px;
    box-shadow: var(--shadow-xs);
    display: flex;
    flex-direction: column;
}

.metric-label {
    font-size: 0.8rem;
    font-weight: 600;
    color: var(--sci-text-subtle);
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin-bottom: 4px;
}

.metric-value {
    font-size: 1.45rem;
    font-weight: 800;
    letter-spacing: -0.02em;
    font-family: 'JetBrains Mono', monospace;
}

.metrics-action-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
    border-top: 1px solid var(--sci-border);
    padding-top: 16px;
}

.left-actions, .right-actions {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

/* Ingredients Card */
.ingredients-card {
    padding: 0;
}

.card-header-bar {
    padding: 18px 24px;
    border-bottom: 1px solid var(--sci-border);
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.card-title {
    font-size: 1.15rem;
    font-weight: 700;
    color: var(--sci-text-main);
    margin: 0;
}

.ingredients-list {
    padding: 16px 24px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.ingredient-card-row {
    display: grid;
    grid-template-columns: 40px 1fr 200px 120px 48px;
    gap: 16px;
    align-items: center;
    padding: 14px 18px;
    background: #ffffff;
    border: 1px solid var(--sci-border);
    border-radius: var(--radius-md);
    transition: all 0.15s ease;
}

.ingredient-card-row:hover {
    border-color: var(--sci-border-hover);
    box-shadow: var(--shadow-card);
}

@media (max-width: 900px) {
    .ingredient-card-row {
        grid-template-columns: 1fr;
        gap: 12px;
    }
}

.ingredient-number {
    font-size: 0.9rem;
    font-weight: 800;
    color: var(--sci-text-subtle);
}

.search-prod-box {
    position: relative;
}

.search-icon-sm {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 0.75rem;
    color: var(--sci-text-subtle);
}

.search-input-sm {
    padding-left: 28px;
    min-height: 32px;
    font-size: 0.8rem;
    background: var(--sci-bg-subtle);
    border-radius: var(--radius-sm);
}

.quantity-input-box {
    position: relative;
    display: flex;
    align-items: center;
}

.quantity-input {
    padding-right: 42px;
    font-family: 'JetBrains Mono', monospace;
    font-weight: 600;
}

.quantity-unit {
    position: absolute;
    right: 12px;
    font-size: 0.75rem;
    font-weight: 700;
    color: var(--sci-text-subtle);
}

.costo-badge {
    display: inline-block;
    padding: 6px 12px;
    background: var(--sci-bg-subtle);
    border: 1px solid var(--sci-border);
    border-radius: var(--radius-sm);
    font-family: 'JetBrains Mono', monospace;
    font-size: 1rem;
    font-weight: 700;
    color: var(--sci-emerald);
}

.btn-delete-row {
    width: 40px;
    height: 40px;
    min-height: 40px;
    padding: 0;
    border-radius: var(--radius-sm);
    display: flex;
    align-items: center;
    justify-content: center;
}

.btn-delete-row:hover {
    background: var(--sci-rose-subtle);
}

.card-footer-bar {
    padding: 16px 24px;
    background: var(--sci-bg-subtle);
    border-top: 1px solid var(--sci-border);
}

/* Empty & Placeholder */
.empty-state {
    padding: 60px 20px;
    text-align: center;
}

.empty-icon, .placeholder-icon {
    font-size: 2.8rem;
    color: var(--sci-text-subtle);
    margin-bottom: 12px;
}

/* Inputs & Buttons */
.form-label-sci {
    font-size: 0.95rem;
    font-weight: 700;
    color: var(--sci-text-main);
    margin-bottom: 4px;
    display: block;
}

.sci-input {
    width: 100%;
    min-height: var(--fitts-target-min);
    padding: 10px 14px;
    font-size: 0.95rem;
    border: 1px solid var(--sci-border);
    border-radius: var(--radius-md);
    background: var(--sci-surface);
    color: var(--sci-text-main);
    transition: all 0.2s ease;
    box-sizing: border-box;
}

.sci-input:focus {
    outline: none;
    border-color: var(--sci-primary);
    box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.15);
}

.sci-select {
    cursor: pointer;
}

.sci-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: var(--fitts-target-min);
    padding: 10px 18px;
    border-radius: var(--radius-md);
    font-size: 0.9rem;
    font-weight: 600;
    cursor: pointer;
    border: 1px solid transparent;
    transition: all 0.2s ease;
    text-decoration: none;
    box-sizing: border-box;
}

.sci-btn-primary {
    background: var(--sci-primary);
    color: #ffffff;
}

.sci-btn-primary:hover {
    background: var(--sci-primary-hover);
    box-shadow: 0 4px 12px rgba(79, 70, 229, 0.25);
}

.sci-btn-secondary {
    background: var(--sci-bg-subtle);
    color: var(--sci-text-main);
    border-color: var(--sci-border);
}

.sci-btn-secondary:hover {
    background: #e2e8f0;
}

.sci-btn-ghost {
    background: transparent;
    color: var(--sci-text-muted);
}

.sci-btn-ghost:hover {
    background: var(--sci-bg-subtle);
    color: var(--sci-text-main);
}

.sci-btn-outline-primary {
    background: #ffffff;
    color: var(--sci-primary);
    border-color: var(--sci-primary-border);
}

.sci-btn-outline-primary:hover {
    background: var(--sci-primary-subtle);
}

.sci-btn-outline-danger {
    background: #ffffff;
    color: var(--sci-rose);
    border-color: var(--sci-rose-border);
}

.sci-btn-outline-danger:hover {
    background: var(--sci-rose-subtle);
}

/* Modals */
.sci-modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(15, 23, 42, 0.6);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    z-index: 1050;
}

.sci-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1060;
    padding: 20px;
    box-sizing: border-box;
}

.sci-modal-dialog {
    width: 100%;
    max-width: 560px;
}

.sci-modal-card {
    background: #ffffff;
    border-radius: var(--radius-xl);
    box-shadow: var(--shadow-popover);
    overflow: hidden;
    display: flex;
    flex-direction: column;
    max-height: 85vh;
}

.sci-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px;
    border-bottom: 1px solid var(--sci-border);
}

.sci-btn-close {
    background: none;
    border: none;
    font-size: 1.5rem;
    color: var(--sci-text-subtle);
    cursor: pointer;
}

.sci-modal-search {
    position: relative;
    padding: 12px 24px;
    background: var(--sci-bg-subtle);
    border-bottom: 1px solid var(--sci-border);
}

.sci-modal-search .search-icon {
    left: 36px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    color: var(--sci-text-subtle);
}

.sci-modal-body {
    padding: 20px 24px;
    overflow-y: auto;
}

.touch-option-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
}

@media (max-width: 540px) {
    .touch-option-grid {
        grid-template-columns: 1fr;
    }
}

.touch-option-card {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 14px;
    border: 1px solid var(--sci-border);
    border-radius: var(--radius-md);
    cursor: pointer;
    transition: all 0.15s ease;
    background: var(--sci-surface);
}

.touch-option-card:hover {
    border-color: var(--sci-primary-border);
    background: var(--sci-primary-subtle);
}

.touch-option-card.is-checked {
    border-color: var(--sci-primary);
    background: var(--sci-primary-subtle);
}

.touch-option-card.is-minus.is-checked {
    border-color: var(--sci-rose);
    background: var(--sci-rose-subtle);
}

.sci-checkbox {
    width: 18px;
    height: 18px;
    accent-color: var(--sci-primary);
    cursor: pointer;
}

.option-details {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
}

.option-name {
    font-size: 0.85rem;
    font-weight: 600;
    color: var(--sci-text-main);
}

.option-price {
    font-size: 0.8rem;
    font-weight: 700;
    color: var(--sci-emerald);
}

.sci-modal-footer {
    padding: 16px 24px;
    border-top: 1px solid var(--sci-border);
    background: var(--sci-bg-subtle);
}
</style>
